import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
const areas = ['Camarillo', 'Oxnard', 'Ventura', 'Thousand Oaks', 'Simi Valley', 'Moorpark', 'Newbury Park', 'Westlake Village', 'Oak Park'];
/** Cities with a dedicated landing page — these chips become internal links. */
const areasWithPages: Record<string, string> = {
  Camarillo: 'camarillo',
  Oxnard: 'oxnard',
  Ventura: 'ventura',
  'Thousand Oaks': 'thousand-oaks',
  'Simi Valley': 'simi-valley',
  Moorpark: 'moorpark',
  'Newbury Park': 'newbury-park',
  'Westlake Village': 'westlake-village'
};
export function ServiceAreas() {
  return <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" id="service-areas" data-id="element-394" data-mp="22u1xretpmona">
      <div className="max-w-4xl mx-auto" data-id="element-395" data-mp="26v3zq3f0hesy">
        <div className="text-center mb-12" data-id="element-396" data-mp="11dtr398rx6g">
          <h2 className="text-3xl sm:text-5xl md:text-6xl font-black uppercase mb-4" data-id="element-397" data-mp="y87rwvwtbey">
            <span className="bg-clip-text text-transparent bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-500" data-id="element-398" data-mp="514qdnlg97iw">
              Mobile Car Detailing Service Areas
            </span>
          </h2>
          <div className="h-1 w-24 bg-red-600 mx-auto rounded-full shadow-[0_0_10px_rgba(220,38,38,0.8)]" data-id="element-399" data-mp="18v9nz37kb4q" />
          <p className="text-gray-400 text-lg max-w-2xl mx-auto mt-4" data-id="element-400" data-mp="g1oorjekip8v">
            Mike's Pro Detail is a mobile business — we bring the detail shop to
            your driveway anywhere in Ventura County and select surrounding
            areas
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3" data-id="element-401" data-mp="3ej0zvw97rjkc">
          {areas.map((area, index) => {
          const slug = areasWithPages[area];
          const chipClasses = 'bg-zinc-900/40 border border-zinc-800 rounded-lg px-3 sm:px-4 py-3 text-center flex items-center justify-center gap-2 hover:border-red-900/50 transition-colors';
          const inner = <>
                <MapPin className="w-4 h-4 text-red-500 flex-shrink-0" aria-hidden="true" data-id="element-402" data-mp="13on4ufyrzv69" />
                <span className="text-gray-300 font-medium text-sm md:text-base leading-tight" data-id="element-403" data-mp="1artk4vun1vae">
                  {area}
                </span>
              </>;
          return <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} data-id="element-404" data-mp="1kr2dbmhoj5vp" data-mpi={index}>
                {slug ? <Link to={`/mobile-detailing-${slug}`} className={`${chipClasses} h-full`} aria-label={`Mobile detailing in ${area}`} data-id="element-405" data-mp="x0yhw2enacfs">
                    {inner}
                  </Link> : <div className={`${chipClasses} h-full`} data-id="element-406" data-mp="11ygj16mf7nd8">{inner}</div>}
              </motion.div>;
        })}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-sm text-center mt-8 text-[#FFFFFF]" data-id="element-407" data-mp="9bvs279uxda7">
          Don't see your area? Call{' '}
          <a href="tel:8183819905" className="text-red-500 font-bold hover:underline" style={{
          fontSize: "24px"
        }} data-id="element-408" data-mp="2rinp34yjf4z8">
            (818) 381-9905
          </a>{' '}
          — we may still be able to come to you!
        </motion.p>
      </div>
    </section>;
}